import { getKeycloak } from './helpers';

const keycloak = getKeycloak();

export default keycloak;
